// src/pages/marketing/LessonDetailPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/marketing/Navbar";
import Hero from "../../components/marketing/Hero";
import ContentBlock from "../../components/marketing/ContentBlock";
import CTAContainer from "../../components/marketing/CTAContainer";
import Footer from "../../components/marketing/Footer";

const LessonDetailPage = () => {
  return (
    <div className="min-h-screen bg-cream-100 text-charcoal-800 font-['Lexend_Deca'] text-base leading-relaxed">
      <Navbar />

      <Hero
        title="Haal meer uit verandertaal!"
        subtitle="Online simulatietraining Motiverende Gespreksvoering voor paramedici"
        height="normal"
      />

      <main className="mx-auto max-w-3xl py-20 px-5 mt-[70px]">
        <ContentBlock title="Over deze training">
          <p>
            In deze training oefen je met basistechnieken van motiverende
            gespreksvoering, zoals vragen stellen en reflecties geven om
            verandertaal uit te lokken. Of je nu al kennis hebt of net begint:
            deze training helpt je om de toepassing in de praktijk te
            versterken. Je frist je kennis op en probeert nieuwe vaardigheden
            uit in een veilige omgeving. Zo stuur je je gesprekken gerichter
            richting verandering en vergroot je de kans op blijvende resultaten
            bij je cliënten.
          </p>
        </ContentBlock>

        <ContentBlock title="Wat leer je?">
          <ul className="list-disc pl-5 space-y-2">
            <li>Open vragen stellen die het gesprek verdiepen</li>
            <li>Open vragen stellen om verandertaal uit te lokken</li>
            <li>Eenvoudige en complexe reflecties formuleren</li>
            <li>Reageren op verandertaal met reflecties</li>
          </ul>
        </ContentBlock>

        <ContentBlock title="Voor wie?">
          <p>
            Deze training is geschikt voor paramedici die al theoretische kennis
            hebben van motiverende gespreksvoering, maar toepassing in de
            praktijk nog lastig vinden.
          </p>
          <p className="mt-3">
            <strong>Doelgroepen:</strong> diëtisten, ergotherapeuten,
            oefentherapeuten, logopedisten, huidtherapeuten, podotherapeuten,
            orthoptisten, optometristen en MBB'ers.
          </p>
        </ContentBlock>

        <ContentBlock title="Praktische informatie" highlight>
          <p>
            <strong>Duur:</strong> 5,5 uur
          </p>
          <p>
            <strong>Accreditatie:</strong> 5,5 punten aangevraagd bij ADAP
          </p>
          <p>
            {" "}
            <strong>Thema's:</strong> verandertaal, open vragen stellen,
            reflecteren, basistechnieken
          </p>
        </ContentBlock>

        <ContentBlock title="Hoe werkt het?">
          <p>
            Je krijgt telkens korte stukjes theorie, gaat direct in gesprek met
            een chatbot en ontvangt persoonlijke feedback op jouw
            gesprekstechnieken. De chatbot en feedback zijn mogelijk gemaakt
            door AI-technologie.
          </p>
        </ContentBlock>

        <CTAContainer
          title="Klaar om te beginnen?"
          text="Schrijf je nu in voor deze interactieve online training!"
          buttonText="Inschrijven"
          buttonLink="/register"
        />
      </main>

      <Footer />
    </div>
  );
};

export default LessonDetailPage;
